import { render, staticRenderFns } from "./ShipmentDetail.vue?vue&type=template&id=72048484&scoped=true"
import script from "./ShipmentDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetail.vue?vue&type=style&index=0&id=72048484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72048484",
  null
  
)

export default component.exports